import AppSearchAPIConnector from "@elastic/search-ui-app-search-connector";
import {
  buildAutocompleteQueryConfig,
  buildSearchOptionsFromConfig,
  getConfig,
  buildFacetConfigFromConfig,
} from "./faq-config-helper";
import appConfig from '../../config';

const { hostIdentifier, searchKey, endpointBase, engineName, facets } = getConfig();
const connector = new AppSearchAPIConnector({
  searchKey,
  engineName,
  hostIdentifier,
  endpointBase
});
const config = {
  searchQuery: {
    filters: [
      { field: "bundle_type", values: ["faq"] },
      { field: 'language_code', values: [appConfig.appLanguage] } // ja, kr, sg, eu, us, cn
    ],
    disjunctiveFacets: facets,
    facets: buildFacetConfigFromConfig(),
    ...buildSearchOptionsFromConfig()
  },
  autocompleteQuery: buildAutocompleteQueryConfig(),
  apiConnector: connector,
  trackUrlState: false,
  alwaysSearchOnInitialLoad: true,
  initialState: {
    resultsPerPage: 10
  }
};

export default config;
